var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreditionCoverE(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 60 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.012 2.753A2.754 2.754 0 0 1 2.765 0h47.909a2.915 2.915 0 0 1 2.913 2.915v73.472A2.614 2.614 0 0 1 50.974 79H2.765a2.754 2.754 0 0 1-2.753-2.753V2.753Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.012 2.753A2.754 2.754 0 0 1 2.765 0h47.909a2.915 2.915 0 0 1 2.913 2.915v73.472A2.614 2.614 0 0 1 50.974 79H2.765a2.754 2.754 0 0 1-2.753-2.753V2.753Zm1.5 0c0-.691.562-1.253 1.253-1.253h47.909c.78 0 1.414.634 1.414 1.415v73.472c0 .614-.5 1.112-1.114 1.112H2.765a1.253 1.253 0 0 1-1.253-1.252V2.753Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M30.201 57.64a.162.162 0 0 1-.048.12.163.163 0 0 1-.12.049h-4.591c-.047 0-.07.023-.07.07v2.17c0 .046.023.07.07.07h3.01a.16.16 0 0 1 .118.049.16.16 0 0 1 .05.119v1.358a.162.162 0 0 1-.05.119.163.163 0 0 1-.119.049h-3.01c-.046 0-.07.023-.07.07v2.268c0 .046.024.07.07.07h4.593a.16.16 0 0 1 .119.049.16.16 0 0 1 .048.119v1.358a.162.162 0 0 1-.048.119.163.163 0 0 1-.12.049h-6.468a.166.166 0 0 1-.167-.168v-9.464c0-.047.017-.087.049-.12a.162.162 0 0 1 .119-.048h6.468a.16.16 0 0 1 .119.049.16.16 0 0 1 .048.119v1.358Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreditionCoverE);
export default __webpack_public_path__ + "static/media/tredition-cover-e.0239e6a20d858be0f15c0578403f2050.svg";
export { ForwardRef as ReactComponent };